// @ts-nocheck
import React, { Component } from 'react'
import { Col, Row, Label } from 'reactstrap'
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingImage from '../../comum/components/LoadingImage';
import FiltroMeuTeconDashboard from './FiltroMeuTeconDashboard';

@observer
export default class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;

        this.renderDashboard = this.renderDashboard.bind(this);
    }

    renderDashboard() {
        if(this.controller.loadingDash) {
            return(
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <LoadingImage />
                </Col>
            )
        } else if(this.controller.listaItensDash.length === 0) {
            return(
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span className="mensagem-filtrar">
                        Não há dados encontrados
                    </span>
                </Col>
            )
        } else {
            return(
                <div className="px-4">
                    <Row>
                        {this.controller.listaItensDash && this.controller.dashboardErro === ""
                        ? this.controller.listaItensDash.map((elemDash, index) => {
                            return(
                                <Col className="card-dashboard px-1" style={{margin: '10px 0 0 0'}} key={index} xs={12} sm={12} md={12} lg={6} xl={4}>
                                    <div className="container-item h-100">
                                        <div className="container card-dashboard__content">
                                            <h2>
                                                {elemDash.NomeDash}
                                            </h2>
                                            <Row className="card-dashboard__itens px-2">
                                                {elemDash.ListaItem.map((item, itemIndex) => {
                                                    return(
                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6} key={itemIndex} className="px-1" onClick={() => {item.Qtd > 0 ? this.controller.abrirModalItem(elemDash.NomeDash, item.NomeCategoria, elemDash.Id, item.Id): null}}>
                                                            <div className={`item ${item.Qtd > 0 ? "clickable" : ""}`}>
                                                                <Row className="px-3 align-itens-center justify-content-between item__content">
                                                                    <div>
                                                                        {item.NomeCategoria}
                                                                    </div>
                                                                    <div>
                                                                        {item.Qtd}
                                                                    </div>
                                                                </Row>
                                                                {
                                                                    item.Qtd > 0 &&
                                                                    <div className="item__icon">
                                                                        <FontAwesomeIcon icon="external-link-square-alt" className="card-detalhe--pop-color" size="lg" />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                        : <div><Label>{this.controller.dashboardErro}</Label></div>
                    }
                    </Row>
                </div>
            )
        }
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col className="mx-0 px-0">
                        <FiltroMeuTeconDashboard controller={this.controller}/>
                    </Col>
                </Row>
                <Row className="dashboard">
                    {this.renderDashboard()}
                </Row>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/meutecon/components/Dashboard.js